module.exports = __webpack_public_path__ + "img/14_18.99374219.png";